<template>
  <div>
    <Loading v-if="loading && !isMobile() && !isErrorPage" @loading-complete="handleAppEnter" />
    <div v-show="!loading || isMobile() || isErrorPage" class="app-container">
      <!-- 头部导航 -->
      <el-header class="header">
        <div class="header-content">
          <div v-if="!menuVisible" class="header-logo">
            <router-link to="/">
              <img v-if="appparams.logo" :src="getUrl(appparams.logo)" class="img-block logo-image" :style="{
                opacity: logoOpacity,
                filter: `blur(${logoBlur}px)`,
                transition: 'opacity 0.3s ease, filter 0.3s ease'
              }" alt="" />
            </router-link>
          </div>
          <div class="header-right">
            <div class="header-nav">
              <el-dropdown ref="mobileDropdown" @command="handleMobileMenuClick" trigger="click">
                <el-button style="color: #999999; font-size: 20px;" type="text"><i
                    class="el-icon-s-operation"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="menuItem in dropdownMenuList" :key="menuItem.index" :command="menuItem">
                    <span style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                      <span>{{ menuItem.title }}</span>
                      <i :class="getMenuIcon(menuItem.title)" style="margin-left: 60px;"></i>
                    </span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-button :style="{ color: menuVisible ? '#000' : '#999999', fontSize: '25px' }" type="text"
                @click="toggleMenu">
                <i :class="menuVisible ? 'el-icon-close' : 'el-icon-s-operation'"></i>
              </el-button> -->
            </div>
          </div>
        </div>
      </el-header>
      <!-- 右侧浮动菜单 -->
      <div v-if="!shouldHideFloatingMenu" class="floating-menu" @mouseenter="expandMenu" @mouseleave="collapseMenu">
        <div class="menu-container" :class="{ 'expanded': isMenuExpanded }">
          <!-- 菜单图片背景 -->
          <div class="menu-image-container">
            <img src="@/assets/images/menu.png" alt="menu" class="menu-image" />
          </div>
          <!-- 菜单项 -->
          <el-menu unique-opened :default-active="activeIndex" class="floating-menu-nav">
            <template v-for="menuItem in (appparams.menuList || [])">
              <!-- 普通菜单项 -->
              <el-menu-item v-if="!menuItem.children" :key="menuItem.index" :index="menuItem.index">
                <span @click="handleMenuClick(menuItem)">{{ menuItem.title }}</span>
              </el-menu-item>
              <!-- 有子菜单的项目，只显示主菜单项 -->
              <el-menu-item v-else :key="menuItem.index" :index="menuItem.index">
                <span @click="handleMenuClick(menuItem)">{{ menuItem.title }}</span>
              </el-menu-item>
            </template>
          </el-menu>
        </div>
      </div>
      <!-- 导航菜单 -->
      <el-drawer :visible.sync="menuVisible" size="100%" :with-header="false" class="nav-drawer">
        <div class="nav-show">
          <div class="nav-show-left">
            <div class="img"
              :style="{ background: appparams.navBackground ? `url(${getUrl(appparams.navBackground)}) center/cover no-repeat` : 'none' }">
            </div>
          </div>
          <div class="nav-show-right">
            <div class="nav-show-right-content">
              <el-menu text-color="#cccccc" active-text-color="#cccccc" unique-opened :default-active="activeIndex"
                class="nav-show-right-nav" :default-openeds="defaultOpeneds">
                <template v-for="menuItem in (appparams.menuList || [])">
                  <!-- 普通菜单项 -->
                  <el-menu-item v-if="!menuItem.children" :key="menuItem.index" :index="menuItem.index">
                    <span @click="handleMenuClick(menuItem)">{{ menuItem.title }}</span>
                  </el-menu-item>
                  <!-- 子菜单 -->
                  <el-submenu v-else :key="menuItem.index" :index="menuItem.index"
                    :class="{ 'is-active': activeIndex === menuItem.index }">
                    <template slot="title">{{ menuItem.title }}</template>
                    <el-menu-item v-for="child in menuItem.children" :key="child.index" :index="child.index">
                      <span @click="handleMenuClick(child)">{{ child.title }}</span>
                    </el-menu-item>
                  </el-submenu>
                </template>
              </el-menu>
              <div class="nav-show-right-bottom">
                <li class="contact-link">
                  <router-link to="/about/contact" tag="span" @click.native="closeMenu">{{ appparams.menuContact
                    }}</router-link>
                </li>
                <div class="nav-show-right-copy">{{ appparams.copyright }}</div>
              </div>
            </div>
          </div>
        </div>
      </el-drawer>
      <!-- 主要内容区域 -->
      <router-view></router-view>
      <!-- 返回顶部按钮 -->
      <el-backtop>
        <img style="width: 40px; height: 40px;" :src="require('@/assets/images/top.png')" alt="返回顶部">
      </el-backtop>
    </div>
  </div>
</template>

<script>
import appmanagerapi from '@/api/AppManager'
import commonapi from '@/api/common'
import Loading from './components/Loading.vue'

export default {
  name: 'App',
  components: { Loading },
  data() {
    return {
      imageUrlCache: {}, // 图片URL缓存
      appparams: {
        menuList: []
      },
      menuVisible: false,
      activeIndex: '1',
      defaultOpeneds: [],
      loading: true, // 初始显示loading页面
      dataLoaded: false, // 标记数据是否已加载
      isMenuExpanded: false, // 菜单是否展开
      appInitialized: false, // 标记应用是否已初始化
      scrollY: 0, // 页面滚动位置
      logoOpacity: 1, // logo透明度
      logoBlur: 0, // logo模糊度
    }
  },
  computed: {
    // 判断是否应该隐藏浮动菜单
    shouldHideFloatingMenu() {
      return this.$route.path.startsWith('/media/detail/');
    },
    // 判断是否是error页面
    isErrorPage() {
      return this.$route.path === '/error' || this.$route.name === 'ErrorPage';
    },
    // 下拉菜单列表
    dropdownMenuList() {
      return this.appparams.menuList || [];
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        // 根据路由路径设置当前激活的菜单项
        this.activeIndex = this.findMenuIndexByPath(to.path) || '1';
      }
    }
  },
  methods: {
    // 检测是否是移动端设备
    isMobile() {
      return window.innerWidth <= 768;
    },
    // 根据菜单标题返回对应的图标
    getMenuIcon(title) {
      const iconMap = {
        '主页': 'el-icon-house',
        '产品': 'el-icon-goods',
        '方案': 'el-icon-menu',
        '关于': 'el-icon-info',
        '媒体': 'el-icon-picture-outline',
      };
      return iconMap[title] || 'el-icon-document';
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    closeSubmenus() {
      // 保留方法以兼容现有代码
    },
    closeMenu() {
      this.menuVisible = false;
    },
    // 处理移动端下拉菜单点击
    handleMobileMenuClick(menuItem) {
      // 手动关闭下拉菜单
      if (this.$refs.mobileDropdown) {
        this.$refs.mobileDropdown.hide();
      }
      // 使用 nextTick 确保下拉菜单完全关闭后再执行跳转
      this.$nextTick(() => {
        this.handleMenuClick(menuItem);
      });
    },
    // 处理菜单点击事件
    handleMenuClick(menuItem) {
      // 关闭菜单
      this.closeMenu();

      // 处理首页导航
      if (menuItem.path === '/') {
        // 如果当前不在主页，先跳转到主页
        if (this.$route.path !== '/') {
          this.$router.push('/').catch(err => {
            // 忽略重复导航错误
            if (err.name !== 'NavigationDuplicated') {
              console.error('路由跳转失败:', err);
            }
          });
        } else {
          // 如果已经在主页，滚动到第一屏
          this.scrollToFirstSection();
        }
      }
      // 处理hash导航到主页solution部分
      else if (menuItem.path === '/#solution') {
        // 如果当前不在主页，先跳转到主页
        if (this.$route.path !== '/') {
          this.$router.push('/').then(() => {
            // 等待路由跳转完成后，滚动到solution部分
            this.$nextTick(() => {
              this.scrollToSolution();
            });
          }).catch(err => {
            // 忽略重复导航错误
            if (err.name !== 'NavigationDuplicated') {
              console.error('路由跳转失败:', err);
            }
            // 即使跳转失败，也尝试滚动到solution部分
            this.scrollToSolution();
          });
        } else {
          // 如果已经在主页，直接滚动到solution部分
          this.scrollToSolution();
        }
      } else {
        // 其他路径使用正常的router-link跳转
        this.$router.push(menuItem.path).catch(err => {
          // 忽略重复导航错误
          if (err.name !== 'NavigationDuplicated') {
            console.error('路由跳转失败:', err);
          }
        });

        // 如果跳转到解决方案页面，停止首页视频播放
        if (menuItem.path === '/solution') {
          this.$bus.$emit('stopVideo');
        }
      }
    },
    // 滚动到第一屏
    scrollToFirstSection() {
      // 使用事件总线通知Home组件滚动到第一屏，移动端不播放视频
      const isMobile = window.innerWidth <= 768;
      this.$bus.$emit('setVideoPlayState', !isMobile); // 只有非移动端才播放视频
      this.$bus.$emit('scrollToHomeSection', 0); // 0是第一屏的索引
    },
    // 滚动到solution部分
    scrollToSolution() {
      // 使用事件总线通知Home组件滚动到solution部分，并设置不播放视频
      this.$bus.$emit('setVideoPlayState', false); // 先设置不播放视频

      // 获取Home组件的实例来动态计算解决方案轮播项的索引
      this.$nextTick(() => {
        const homeComponent = this.$children.find(child => child.$options.name === 'HomePage');
        if (homeComponent && homeComponent.getSolutionCarouselIndex) {
          const solutionIndex = homeComponent.getSolutionCarouselIndex();
          this.$bus.$emit('scrollToHomeSection', solutionIndex);
        } else {
          // 如果无法获取动态索引，使用默认值2（适用于没有projectimglist的情况）
          this.$bus.$emit('scrollToHomeSection', 2);
        }
      });
    },
    expandMenu() {
      this.isMenuExpanded = true;
    },
    collapseMenu() {
      this.isMenuExpanded = false;
    },
    // 解析从后端收到的非标准JSON字符串
    parseNonStandardJsonString(jsonString) {
      if (typeof jsonString !== 'string') {
        return jsonString;
      }
      try {
        // 将JS对象写法的字符串修正为标准JSON格式
        // 1. 将键名用双引号包裹： e.g. {key: -> {"key":
        let correctedString = jsonString.replace(/([{,])\s*(\w+)\s*:/g, '$1"$2":');
        // 2. 将值中的单引号替换为双引号： e.g. '/path' -> "/path"
        correctedString = correctedString.replace(/'/g, '"');
        return JSON.parse(correctedString);
      } catch (e) {
        console.error('无法解析后端返回的字符串:', jsonString, e);
        return []; // 返回空数组以防页面崩溃
      }
    },
    // 根据 index 查找 path
    findMenuPathByIndex(index) {
      if (!this.appparams.menuList || !Array.isArray(this.appparams.menuList)) {
        return '/';
      }
      for (const item of this.appparams.menuList) {
        if (item.index === index) return item.path;
        if (item.children) {
          for (const child of item.children) {
            if (child.index === index) return child.path;
          }
        }
      }
      return '/';
    },
    // 根据 path 查找 index
    findMenuIndexByPath(path) {
      if (!this.appparams.menuList || !Array.isArray(this.appparams.menuList)) {
        return '1';
      }
      for (const item of this.appparams.menuList) {
        if (item.path === path) return item.index;
        // 特殊处理：产品详情页面应该匹配产品菜单项
        if (item.path === '/product' && path.startsWith('/product/productdetail/')) {
          return item.index;
        }
        if (item.children) {
          for (const child of item.children) {
            if (child.path === path) return child.index;
          }
        }
      }
      return '1';
    },
    getAppData() {
      return appmanagerapi.getAppData().then(res => {
        this.appparams = res.data.params;
        let params = res.data.params;
        if (params.menuList) {
          params.menuList = this.parseNonStandardJsonString(params.menuList);
        }
        // 将处理后的数据赋值给appparams
        this.appparams = { ...this.appparams, ...params };
        return res; // 返回结果以便调用者知道成功
      }).catch(error => {
        console.error('获取App数据失败:', error);
        throw error; // 重新抛出错误以便调用者处理
      });
    },
    waitImagesLoaded() {
      return new Promise(resolve => {
        this.$nextTick(() => {
          const imgs = Array.from(document.images);
          if (imgs.length === 0) return resolve();
          let loaded = 0;
          imgs.forEach(img => {
            if (img.complete) {
              loaded++;
              if (loaded === imgs.length) resolve();
            } else {
              img.onload = img.onerror = () => {
                loaded++;
                if (loaded === imgs.length) resolve();
              };
            }
          });
        });
      });
    },
    checkImagesAvailability() {
      return new Promise(resolve => {
        this.$nextTick(() => {
          const imgs = Array.from(document.images);
          if (imgs.length === 0) return resolve();

          // 快速检查：如果大部分图片已经加载完成，就认为资源可用
          const loadedImages = imgs.filter(img => img.complete);
          const loadRatio = loadedImages.length / imgs.length;

          // 如果超过70%的图片已加载，或者等待500ms后，就认为资源可用
          if (loadRatio >= 0.7) {
            resolve();
          } else {
            setTimeout(() => {
              resolve();
            }, 500);
          }
        });
      });
    },
    checkCachedData() {
      // 检查是否有基本的应用数据
      return this.appparams &&
        this.appparams.menuList &&
        this.appparams.menuList.length > 0;
    },
    // 处理用户点击logo进入应用
    async handleAppEnter() {
      if (this.appInitialized) return; // 如果已经初始化，直接返回

      this.appInitialized = true;
      // console.log('用户点击logo，开始加载应用数据...');

      // 移动端直接跳过loading，直接加载数据
      if (this.isMobile()) {
        try {
          await this.getAppData();
          this.dataLoaded = true;
        } catch (error) {
          console.error('获取应用数据失败:', error);
        }
        return;
      }

      try {
        // 检查是否有缓存的数据
        if (this.checkCachedData()) {
          this.dataLoaded = true;
          this.loading = false;
          return;
        }

        // 设置一个快速超时，如果数据获取很快，就不显示loading
        const quickTimeout = setTimeout(() => {
          if (!this.dataLoaded) {
            // 如果100ms内没有获取到数据，开始显示loading
            this.loading = true;
          }
        }, 100);

        // 设置一个最大超时时间，避免长时间显示loading
        const maxTimeout = setTimeout(() => {
          this.loading = false;
        }, 2000); // 最多显示2秒loading

        await this.getAppData();

        // 等待图片加载完成
        await this.waitImagesLoaded();

        // 清除超时
        clearTimeout(quickTimeout);
        clearTimeout(maxTimeout);

        // 数据和图片都加载成功
        this.loading = false;
        this.dataLoaded = true;

      } catch (error) {
        console.error('获取应用数据失败:', error);
        this.loading = false;
      }
    },
    getUrl(imagePath) {
      if (!imagePath) return '';

      // 如果已经有缓存的URL，直接返回
      if (this.imageUrlCache && this.imageUrlCache[imagePath]) {
        return this.imageUrlCache[imagePath];
      }

      // 初始化缓存对象
      if (!this.imageUrlCache) {
        this.imageUrlCache = {};
      }

      // 发起请求获取URL
      commonapi.getImageUrl(imagePath).then(res => {
        const url = res.data.url;
        // 使用Vue.set确保响应式更新
        this.$set(this.imageUrlCache, imagePath, url);
      }).catch(error => {
        console.error('获取图片URL失败:', error);
        // 缓存空字符串，避免重复请求
        this.$set(this.imageUrlCache, imagePath, '');
      });

      // 返回空字符串，等待异步请求完成后通过响应式更新
      return '';
    },
    // 处理滚动事件
    handleScroll() {
      this.scrollY = window.pageYOffset || document.documentElement.scrollTop;

      // 当滚动超过100px时开始应用模糊和透明度效果
      const scrollThreshold = 100;
      const maxScroll = 300; // 最大滚动距离，超过此距离效果达到最大

      if (this.scrollY <= scrollThreshold) {
        // 未达到阈值，保持原始状态
        this.logoOpacity = 1;
        this.logoBlur = 0;
      } else if (this.scrollY <= maxScroll) {
        // 在阈值和最大值之间，计算渐变效果
        const progress = (this.scrollY - scrollThreshold) / (maxScroll - scrollThreshold);
        this.logoOpacity = Math.max(0.3, 1 - progress * 0.7); // 透明度从1渐变到0.3
        this.logoBlur = progress * 3; // 模糊度从0渐变到3px
      } else {
        // 超过最大值，应用最大效果
        this.logoOpacity = 0.3;
        this.logoBlur = 3;
      }
    },
    // 添加滚动监听器
    addScrollListener() {
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    },
    // 移除滚动监听器
    removeScrollListener() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
  async mounted() {
    // 移动端直接初始化应用，不显示loading页面
    if (this.isMobile()) {
      await this.handleAppEnter();
    }
    // 桌面端应用启动时只显示loading页面，等待用户点击logo
    // 不自动加载数据，让用户主动进入应用
    // console.log('应用已启动，等待用户点击logo进入');

    // 添加滚动监听器
    this.addScrollListener();
  },
  beforeDestroy() {
    // 清理滚动监听器
    this.removeScrollListener();
  },
}
</script>

<style>
.app-container {
  min-height: 100vh;
  background-color: #000;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  padding: 20px 0;
  transition: all 0.3s ease;
}

.header-content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-logo {
  margin-left: 2%;
}

.header-logo img {
  width: 150px;
}

.logo-image {
  transition: opacity 0.3s ease, filter 0.3s ease;
}

.header-right {
  margin-right: 2%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}

.header-nav {
  display: none;
}

/* 移动端显示下拉菜单 */
@media screen and (max-width: 768px) {
  .header-nav {
    display: block;
  }

  .header {
    background-color: black;
  }
}

.header-language a {
  color: #fff;
  text-decoration: none;
  margin: 0 5px;
}

.header-language a.cur {
  color: #409EFF;
}

.nav-show {
  height: 100%;
  display: flex;
}

.el-drawer__body {
  overflow: hidden !important;
}

.nav-show-left {
  width: 50%;
  background: #000;
}

.nav-show-right {
  background-color: white;
  width: 50%;
}

.nav-show-right-content {
  height: 85%;
  margin-top: 15%;
  margin-left: 8%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.nav-show-right-nav {
  color: #cccccc;
  background: transparent;
  border: none;
}

.nav-show-right-bottom {
  margin-top: auto;
  text-align: left;
  margin-bottom: 5%;
}

.contact-link {
  color: black;
  font-size: 1.5vw;
  list-style: none;
  margin-bottom: 1vw;
}

.contact-link span {
  cursor: pointer;
  transition: color 0.3s ease;
}


.nav-show-right-copy {
  color: #666;
  font-size: 1.2vw;
}

.nav-show-right-nav .el-menu-item {
  font-size: 2.5vw;
  background-color: transparent !important;
  margin: 0.8vw 0;
}

.nav-show-right-nav .el-menu-item:hover {
  background-color: transparent !important;
  color: #000 !important;
}

.nav-show-right-nav .el-submenu__title {
  font-size: 2.5vw !important;
  background-color: transparent !important;
  margin: 0.8vw 0;
}

.nav-show-right-nav .el-submenu__title:hover {
  background-color: transparent !important;
  color: #000 !important;
}

/* 子菜单项样式 */
.nav-show-right-nav .el-submenu .el-menu-item {
  font-size: 1.8vw !important;
  margin: 0.2vw 0;
  padding-left: 2vw !important;
}

.nav-show-right-nav .el-submenu .el-menu-item:hover {
  background-color: transparent !important;
  color: #000 !important;
}

/* 子菜单容器样式 */
.nav-show-right-nav .el-submenu .el-menu {
  padding: 0.5vw 0;
}

/* 下拉菜单样式 */
.el-dropdown-menu {
  background-color: #4a4a4a !important;
  border: none !important;
}



/* 隐藏下拉菜单的箭头 */
.el-popper[x-placement^="bottom"] .popper__arrow,
.el-popper[x-placement^="bottom"] .popper__arrow::after {
  display: none !important;

}

.el-dropdown-menu__item {
  font-size: 2.5vw;
  color: #ffffff !important;
  background-color: #4a4a4a !important;
  border-top: 1px solid #666666 !important;
}

/* 隐藏第一个菜单项的分割线 */
.el-dropdown-menu__item:first-child {
  border-top: none !important;
}

.el-dropdown-menu__item:hover {
  background-color: #666666 !important;
  color: #ffffff !important;
}

/* 添加最小和最大字体大小限制 */
@media screen and (max-width: 1200px) {

  .nav-show-right-nav .el-submenu__title,
  .nav-show-right-nav .el-menu-item,
  .el-dropdown-menu__item {
    font-size: 15px !important;
  }

  .nav-show-right-nav .el-submenu .el-menu-item {
    font-size: 12px !important;
    padding-left: 20px !important;
    margin: 2px 0;
  }

  .contact-link {
    font-size: 14px;
    margin-right: 15px;
  }

  .nav-show-right-copy {
    font-size: 12px;
  }
}

@media screen and (min-width: 1920px) {

  .nav-show-right-nav .el-submenu__title,
  .nav-show-right-nav .el-menu-item,
  .el-dropdown-menu__item {
    font-size: 35px !important;
  }

  .nav-show-right-nav .el-submenu .el-menu-item {
    font-size: 25px !important;
  }

  .contact-link {
    font-size: 20px;
    margin-right: 30px;
  }

  .nav-show-right-copy {
    font-size: 16px;
  }
}

/* 右侧浮动菜单样式 */
.floating-menu {
  position: fixed;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
}

.menu-container {
  position: relative;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* 菜单图片容器 */
.menu-image-container {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: -1;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  overflow: hidden;
}

.menu-image {
  width: 50px;
  height: auto;
  object-fit: contain;
  opacity: 0;
  transform: translateX(100%);
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* 展开状态下的图片 */
.menu-container.expanded .menu-image {
  opacity: 1;
  transform: translateX(0);
  width: 3.2vw;
  height: auto;
}

.floating-menu-nav {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
  width: 120px !important;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.menu-container.expanded .floating-menu-nav {
  width: 150px !important;
}

/* 创建更弯曲的半圆形效果 - 5个菜单项形成更明显的弧形 */
.menu-container.expanded .floating-menu-nav .el-menu-item:nth-child(1) {
  transform: translateX(-2.5vw) translateY(-40px);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.menu-container.expanded .floating-menu-nav .el-menu-item:nth-child(2) {
  transform: translateX(-4.5vw) translateY(-25px);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.menu-container.expanded .floating-menu-nav .el-menu-item:nth-child(3) {
  transform: translateX(-6vw) translateY(0px);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.menu-container.expanded .floating-menu-nav .el-menu-item:nth-child(4) {
  transform: translateX(-4.5vw) translateY(25px);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.menu-container.expanded .floating-menu-nav .el-menu-item:nth-child(5) {
  transform: translateX(-2.5vw) translateY(40px);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.floating-menu-nav .el-menu-item.is-active {
  color: #ffffff !important;
  background: transparent !important;
  transition: all 0.3s ease;
}

.floating-menu-nav .el-menu-item.is-active span {
  display: inline-block;
  transform: translateY(3px);
  text-shadow: 0 0 10px #717eb9, 0 0 20px #717eb9;
  transition: all 0.3s ease;
}

.floating-menu-nav .el-menu-item {
  color: white !important;
  font-size: 1vw;
  margin: 15px 0;
  text-align: right;
  background: transparent !important;
  padding: 0 !important;
  height: auto !important;
  line-height: normal !important;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  white-space: nowrap;
  transform: translateX(0);
  cursor: pointer;
}

.floating-menu-nav .el-menu-item:hover {
  color: #ffffff !important;
  background-color: transparent !important;
}

/* 悬停时的额外偏移效果 */
.menu-container:not(.expanded) .floating-menu-nav .el-menu-item:hover {
  transform: translateX(-6px);
  color: #ffffff !important;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
}

.menu-container.expanded .floating-menu-nav .el-menu-item:nth-child(1):hover {
  transform: translateX(-3vw) translateY(-45px) scale(1.1);
  color: #ffffff !important;
  text-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
}

.menu-container.expanded .floating-menu-nav .el-menu-item:nth-child(2):hover {
  transform: translateX(-5vw) translateY(-30px) scale(1.1);
  color: #ffffff !important;
  text-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
}

.menu-container.expanded .floating-menu-nav .el-menu-item:nth-child(3):hover {
  transform: translateX(-6.5vw) translateY(-5px) scale(1.1);
  color: #ffffff !important;
  text-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
}

.menu-container.expanded .floating-menu-nav .el-menu-item:nth-child(4):hover {
  transform: translateX(-5vw) translateY(20px) scale(1.1);
  color: #ffffff !important;
  text-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
}

.menu-container.expanded .floating-menu-nav .el-menu-item:nth-child(5):hover {
  transform: translateX(-3vw) translateY(35px) scale(1.1);
  color: #ffffff !important;
  text-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
}

.floating-menu-nav a {
  color: inherit;
  text-decoration: none;
  display: inline-block !important;
  width: 100%;
  text-align: center;
}



.nav-show-right-nav .el-submenu.is-active>.el-submenu__title {
  color: #000000 !important;
}

@media screen and (max-width: 768px) {
  .floating-menu {
    display: none;
  }
}

@media screen and (max-width: 1200px) {
  .menu-image {
    width: 40px;
    height: auto;
  }

  .menu-container.expanded .menu-image {
    width: 65px;
    height: auto;
  }

  .floating-menu-nav {
    width: 100px !important;
  }

  .menu-container.expanded .floating-menu-nav {
    width: 130px !important;
  }

  .floating-menu-nav .el-menu-item {
    font-size: 1vw;
    padding: 0 !important;
    margin: 15px 0;
  }
}

/* 菜单动画 */
.el-menu-item {
  transition: all 0.3s ease;
}

/* 返回顶部按钮动画 */
.el-backtop {
  transition: all 0.3s ease;
}

.el-backtop:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>